import { createFetcher, ROUTES } from '../api'

export const fetchTMRenewal = createFetcher<TMRenewal, any, { order_item_id: string }>({
  url: ROUTES.TMRENEWAL.GET_ONE,
  withTokens: true
})

export interface TMRenewal{
  classes: string
}